import React from 'react';
import { Form, Input, Button, message, Modal } from 'antd';
import { connect } from 'react-redux';
import { checkEmail, checkPassword, checkPhone, checkUsername, exitEmail, exitPhone, exitUsername, register } from './register.service';
import { useHistory } from 'react-router';

// 调整Form布局，让输入框占满剩余宽度（配合30px间距）
const formItemLayout = {
  labelCol: {
    xs: { span: 24 }, // 移动端：标签占满整行
    sm: { span: 7 },  // 桌面端：标签宽度适度缩小，给输入框留空间
  },
  wrapperCol: {
    xs: { span: 24 }, // 移动端：输入框占满整行
    sm: { span: 17 }, // 桌面端：输入框占满剩余宽度（24-7=17）
  },
};

// 按钮布局与输入框对齐，取消多余偏移
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 17, // 与输入框宽度一致（17格）
      offset: 7, // 与标签宽度一致（7格），实现对齐
    },
  },
};

// 修正props类型：editshow是修改状态的函数，接收boolean参数
function Register(props: {
  show: boolean;
  editshow: (value: boolean) => void; // 关键：定义为接收boolean的函数类型
}) {
  const [form] = Form.useForm();
  const history = useHistory();

  const onFinish = (values: any) => {
    register(Object.assign({
      USER_NAME: '',
      USER_PASSWD: '',
      USER_MAIL: '',
      USER_PHONE: '',
      USER_ADDRESS: '',
      USER_COMPANY: '',
    }, {
      USER_NAME: values.username,
      USER_PASSWD: values.password,
      USER_MAIL: values.email,
      USER_PHONE: values.phone,
      USER_ADDRESS: values.address,
      USER_COMPANY: values.company,
    })).then(() => {
      message.info(`注册成功`);
      history.goBack();
      props.editshow(false); // 注册成功后，调用editshow关闭弹窗
    }).catch((error: Error) => {
      message.error(error.message);
    });
  };

  // 取消按钮回调：直接关闭弹窗
  const handleCancel = () => {
    props.editshow(false);
  };

  return (
    <Modal
      title="注册"
      open={props.show}
      // 关键1：添加onCancel回调，点击右上角×或遮罩层时关闭
      onCancel={handleCancel}
      maskClosable={false} // 点击遮罩不关闭（如需支持遮罩关闭，可改为true）
      style={{ width: '90%', maxWidth: '700px' }}
      bodyStyle={{ padding: '20px 0' }}
      // 关键2：Modal底部添加“取消”按钮（与注册按钮配合）
      footer={[
       
      ]}
    >
      <Form
        {...formItemLayout}
        form={form}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        style={{
          width: '100%',
          padding: '0 30px', // 左右30px间距，居中显示
          marginTop: '20px',
          marginLeft: '-40px'
        }}
      >
        <Form.Item
          name="username"
          label="用户名"
          rules={[
            { required: true, message: '请输入您的用户名!', whitespace: true },
            { validator(_, value) { return checkUsername(value); } },
            { validator(_, value) { return exitUsername(value); } },
          ]}
        >
          <Input style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="password"
          label="密码"
          rules={[
            { required: true, message: '请输入您的密码!' },
            { validator(_, value) { return checkPassword(value); } },
          ]}
          hasFeedback
        >
          <Input.Password style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="confirm"
          label="确认密码"
          dependencies={['password']}
          hasFeedback
          rules={[
            { required: true, message: '请再次输入您的密码!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('确认密码必须跟密码一致!'));
              },
            }),
          ]}
        >
          <Input.Password style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            { required: true, message: '请输入您的E-mail!' },
            { validator(_, value) { return checkEmail(value); } },
            { validator(_, value) { return exitEmail(value); } },
          ]}
        >
          <Input style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="phone"
          label="电话"
          rules={[
            { required: true, message: '请输入您的电话!' },
            { validator(_, value) { return checkPhone(value); } },
            { validator(_, value) { return exitPhone(value); } },
          ]}
        >
          <Input style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="company"
          label="单位"
          rules={[
            { required: true, message: '请输入您的单位!' },
          ]}
        >
          <Input style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="address"
          label="地址"
          rules={[
            { required: true, message: '请输入您的地址!' },
          ]}
        >
          <Input style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              width: '120%',
              // margin: '0 auto',
              display: 'block',
              marginLeft: '-60px'
            }}
          >
            注册
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default connect(null, {})(Register);